module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    ref: "select",
    attrs: {
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "value",
      "clearable": !_vm.disabled,
      "outlined": !_vm.disabled,
      "filled": _vm.disabled,
      "dense": "",
      "hide-details": "true",
      "label": "Viewing Stream",
      "id": "viewing_stream_select",
      "readonly": _vm.disabled
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45e35ebd","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/StreamingSelect.vue
// module id = 2060
// module chunks = 0